import { Icon } from '@pickleballinc/ui/components/ui/icon';
import { Dispatch, SetStateAction } from 'react';

import PlayerCard from '@/app/team-leagues/[teamLeagueId]/(secure)/teams/[teamId]/player-moves/add-player/_components/player-card';
import AvailablePlayersArea from '@/components/molecules/AvailablePlayersArea';
import DroppableArea from '@/components/molecules/DroppableArea';
import { TeamPlayerInfo } from '@/lib/types';

interface StepOneProps {
	droppedPlayers: TeamPlayerInfo[];
	availablePlayers: TeamPlayerInfo[];
	setDroppedPlayers: Dispatch<SetStateAction<TeamPlayerInfo[]>>;
	setAvailablePlayers: Dispatch<SetStateAction<TeamPlayerInfo[]>>;
}

export function StepOne({ droppedPlayers, availablePlayers, setDroppedPlayers, setAvailablePlayers }: StepOneProps) {
	const handleDrop = (player: TeamPlayerInfo) => {
		if (!droppedPlayers.some((p) => p.uuid === player.uuid)) {
			setDroppedPlayers((prev) => [...prev, player]);
		}
		setAvailablePlayers((prev) => prev.filter((p) => p.uuid !== player.uuid));
	};

	const handleCheckbox = (player: TeamPlayerInfo, checked: boolean) => {
		setDroppedPlayers((prev) => (checked ? [...prev, player] : prev.filter((p) => p.uuid !== player.uuid)));
	};

	const handleReturn = (player: TeamPlayerInfo) => {
		setDroppedPlayers((prev) => prev.filter((p) => p.uuid !== player.uuid));
		if (!availablePlayers.some((p) => p.uuid === player.uuid)) {
			setAvailablePlayers((prev) => [...prev, player]);
		}
	};

	return (
		<>
			<div className="hidden gap-1 lg:flex">
				<AvailablePlayersArea availablePlayers={availablePlayers} onDrop={handleReturn} />
				<Icon glyph="arrow-left-orange" className="rotate-180" />
				<DroppableArea droppedPlayers={droppedPlayers} onDrop={handleDrop} />
			</div>
			<div className="flex flex-wrap gap-4 lg:hidden">
				{availablePlayers.map((player) => (
					<PlayerCard
						key={player.uuid}
						name={player.firstName + ' ' + player.lastName}
						phone={player.phone}
						internationalCountryCallingCode={player.country?.internationalCountryCallingCode || ''}
						duprDoubles={player.ratingDoubles}
						duprSingles={player.ratingSingles}
						image={player.photo}
						onCheck={(checked: boolean) => handleCheckbox(player, checked)}
					/>
				))}
			</div>
		</>
	);
}
